module.exports = __webpack_public_path__ + "static/media/D546GriffinStNW_2018-06-05_15.e21d7ed4.jpg";